import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const TransparencyOutline2Icon = (t0)=>{
    const $ = c(6);
    const { width, height, color } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 1.5C10.8403 1.5 13.2531 3.3225 14.1377 5.86133C16.6771 6.74555 18.5 9.15923 18.5 12C18.5 15.5899 15.5899 18.5 12 18.5C9.15923 18.5 6.74555 16.6771 5.86133 14.1377C3.3225 13.2531 1.5 10.8403 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5ZM14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C7.88765 14.5 7.77599 14.4968 7.66504 14.4912C8.52838 15.9903 10.1459 17 12 17C14.7614 17 17 14.7614 17 12C17 10.1459 15.9903 8.52838 14.4912 7.66504C14.4968 7.77599 14.5 7.88765 14.5 8ZM7.25684 10.417C7.09085 10.9146 7 11.4466 7 12C7 12.3123 7.03018 12.6176 7.08496 12.9141C7.38175 12.969 7.68731 13 8 13C8.55316 13 9.08463 12.908 9.58203 12.7422L7.25684 10.417ZM8 3C5.23858 3 3 5.23858 3 8C3 9.85364 4.00939 11.4705 5.50781 12.334C5.50221 12.2234 5.5 12.112 5.5 12C5.5 8.41015 8.41015 5.5 12 5.5C12.112 5.5 12.2234 5.50221 12.334 5.50781C11.4705 4.00939 9.85364 3 8 3ZM9.02148 7.98242C8.62636 8.27584 8.27584 8.62636 7.98242 9.02148L10.9775 12.0166C11.3728 11.7231 11.7231 11.3728 12.0166 10.9775L9.02148 7.98242ZM12 7C11.4466 7 10.9146 7.09085 10.417 7.25684L12.7422 9.58203C12.908 9.08463 13 8.55316 13 8C13 7.68731 12.969 7.38175 12.9141 7.08496C12.6176 7.03018 12.3123 7 12 7Z",
            fill: color
        });
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== height || $[3] !== t1 || $[4] !== width) {
        t2 = /*#__PURE__*/ jsx("svg", {
            width: width,
            height: height,
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: t1
        });
        $[2] = height;
        $[3] = t1;
        $[4] = width;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
export { TransparencyOutline2Icon };
